import React, { useMemo } from "react";
import { FunctionSubscriberContext } from "./FunctionSubscriberContext";
import { buildFlowApiCalls, PlexPostFn, PlexNavigateFn } from "./FlowApiCalls";

export type { PlexPostFn, PlexNavigateFn };

export type FunctionSubscriberContextProps = {
  plexPost: PlexPostFn;
  plexNavigate: PlexNavigateFn;
  // Stays host-provided — jQuery dependency lives in the host.
  plexShowOverlay: (status: boolean) => void;
  children: React.ReactNode;
};

// The shape exposed via context to consumers — the built API calls plus the host-provided overlay toggle.
export type FunctionSubscriberValue = ReturnType<typeof buildFlowApiCalls> & {
  plexShowOverlay: (status: boolean) => void;
};

export const FunctionSubscriberProvider: React.FC<FunctionSubscriberContextProps> = ({
  plexPost,
  plexNavigate,
  plexShowOverlay,
  children
}) => {
  const apiCalls = useMemo(() => buildFlowApiCalls(plexPost, plexNavigate), [plexPost, plexNavigate]);

  const contextValue = useMemo(
    () => ({
      plexShowOverlay,
      ...apiCalls
    }),
    [plexShowOverlay, apiCalls]
  );

  return (
    <FunctionSubscriberContext.Provider value={contextValue}>
      {children}
    </FunctionSubscriberContext.Provider>
  );
};
